const DO_NOT_TRACK_PROPERTY_KEY = 'dnt'

function getUserTrackingPreferences() {
  const value = window.localStorage.getItem(DO_NOT_TRACK_PROPERTY_KEY)
  return {
    value,
    isTrackingAllowed: value === '0',
  }
}

export default getUserTrackingPreferences
